module.exports = __webpack_public_path__ + "img/1564946219.e6fb021a.jpg";